export default {
      id: "common__add_lg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__add_lg",
      toString: function () {
        return this.url;
      }
    }